module.exports = __webpack_public_path__ + "static/img/plug11.40b7017b.png";